import { TemplatePageProps } from './types'
import { NumbersBlitzEntity } from './entity'
import Icon from 'images/games/2048-blitz/icon.png'
import Detail1 from 'images/games/2048-blitz/detail1.png'
import {
  BingoClashLink,
  DominoesLink,
  DunkShotLink,
  MatchNFlipLink,
  PlaySolitaireOnlineLink,
  Pocket7GamesLink,
  PoolClashLink,
  TileBlitzLink,
  TwentyOneGoldLink,
} from '../../components'
import { Pocket7GamesSwiper } from './pocket7games'

export const NumbersBlitzDetail: TemplatePageProps = {
  entity: {
    ...NumbersBlitzEntity,
    logo: Icon,
    title: <>2048 Blitz: 2048 Online Brain Challenge</>,
    description: (
      <>
        2048 Blitz puts a thrilling spin on the classic <strong>2048 game online!</strong> Merge matching tiles, sharpen
        your logic, and race to reach 2048! Available on the Pocket7Games app, it’s the perfect number challenge for
        quick thinkers. Download Pocket7Games now—Available on the App Store, Galaxy Store, or as an Android APK!
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: <>How to Play 2048 Blitz</>,
      description: (
        <>
          Get ready to challenge your mind with this fun <strong>number puzzle</strong>. Simply swipe tiles with
          identical numbers—up, down, left, or right, to merge them, adding their values into a single tile. Each match
          has three goals to complete, achieved by creating a set number of the target tiles. If you run out of tiles of
          the same value, swiping will place another 2-tile on the board so you can keep building. Complete the target
          tile goals within the time limit to earn more points, plus bonus points for time remaining when a match ends.
          The quicker you complete the tile goals, the more Time Bonus points you’ll earn!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Looking for More Brain-Teasing Fun?</>,
      description: (
        <>
          2048 Blitz delivers an adrenaline-charged number challenge where every swipe tests your logic and speed. With
          quick rounds and rewarding gameplay, hitting target tiles is a satisfying goal. Want even more brain games?
          Head to the <Pocket7GamesLink>Pocket7Games app</Pocket7GamesLink> and try <BingoClashLink />,{' '}
          <MatchNFlipLink />, <TwentyOneGoldLink />, <TileBlitzLink />, <PoolClashLink />, <DunkShotLink />,{' '}
          <DominoesLink />, and <PlaySolitaireOnlineLink /> No matter your playstyle, you&#39;ll find a game meant for
          you. Download now and start playing!
        </>
      ),
    },
  ],
} as TemplatePageProps
